/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  DeleteApiV1PersonIdAttachmentsAttachmentidMutationResponse,
  DeleteApiV1PersonIdAttachmentsAttachmentidPathParams,
  DeleteApiV1PersonIdAttachmentsAttachmentid401,
  DeleteApiV1PersonIdAttachmentsAttachmentid404,
  DeleteApiV1PersonIdAttachmentsAttachmentid500,
} from "../../types/personDocumentsController/DeleteApiV1PersonIdAttachmentsAttachmentid.ts";

function getDeleteApiV1PersonIdAttachmentsAttachmentidUrl(
  id: DeleteApiV1PersonIdAttachmentsAttachmentidPathParams["id"],
  attachmentId: DeleteApiV1PersonIdAttachmentsAttachmentidPathParams["attachmentId"],
) {
  const res = {
    method: "DELETE",
    url: `/api/v1/person/${id}/attachments/${attachmentId}` as const,
  };
  return res;
}

/**
 * @description Soft delete (Active=false). O blob é apagado em best-effort. **(Requer Authorization para autenticação)**
 * @summary Excluir anexo (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/attachments/:attachmentId}
 */
export async function deleteApiV1PersonIdAttachmentsAttachmentid(
  id: DeleteApiV1PersonIdAttachmentsAttachmentidPathParams["id"],
  attachmentId: DeleteApiV1PersonIdAttachmentsAttachmentidPathParams["attachmentId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiV1PersonIdAttachmentsAttachmentidMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1PersonIdAttachmentsAttachmentid401
      | DeleteApiV1PersonIdAttachmentsAttachmentid404
      | DeleteApiV1PersonIdAttachmentsAttachmentid500
    >,
    unknown
  >({
    method: "DELETE",
    url: getDeleteApiV1PersonIdAttachmentsAttachmentidUrl(
      id,
      attachmentId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
